import PropTypes from "prop-types";
import { JoinSpaceButton } from "@/react/components/Spaces/JoinSpaceButton";
import { isCommunityAdmin } from "@/react/helpers/communityMemberHelpers";
import { isSpaceMember } from "@/react/helpers/spaceHelpers";
import { usePunditUserContext } from "@circle-react/contexts";
import { isChatSpace } from "@circle-react/helpers/spaceHelpers";

export const NotSpaceMemberActions = ({ space }) => {
  const { currentCommunityMember, currentUser } = usePunditUserContext();
  const isPrivateSpace = space.is_private;

  const shouldShowJoinSpaceButton =
    (!isPrivateSpace && currentUser && !isSpaceMember(space)) ||
    isCommunityAdmin(currentCommunityMember);

  const isSpaceChatSpace = isChatSpace(space);
  const isMemberLimitReached =
    isSpaceChatSpace && space?.space_members_limit_reached;

  return (
    <div>
      {shouldShowJoinSpaceButton && (
        <JoinSpaceButton space={space} disabled={isMemberLimitReached} />
      )}
    </div>
  );
};

NotSpaceMemberActions.propTypes = {
  space: PropTypes.object.isRequired,
};
